export default __webpack_public_path__ + "static/media/graanaLogo.af6b9c24.svg";